export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SETLAYOUT = "SETLAYOUT";
export const SETKEY = "SETKEY";
export const SETCONTRASTLAYOUT = "SETCONTRASTLAYOUT"
export const SETBASEFONTSIZE = "SETBASEFONTSIZE"
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME'
export const SET_LOCALES = "SET_LOCALES"
export const PUSH_LOCALES = "PUSH_LOCALES"